export const MAN = "man"
export const WOMAN = "woman"
export const ORGANIZATION = "organization"
